export default {
  data() {
    return {
      uploadUrl: this.$api.url_upload,   // 图片上传地址
      fileList_1: [],                    // 已上传成功图片列表
      fileList_2: [],                    // 已上传成功图片列表
      fileList_3: [],                    // 已上传成功图片列表
      fileList_4: [],                    // 已上传成功图片列表
      fileList_5: [],                    // 已上传成功图片列表
      fileList_6: [],                    // 已上传成功图片列表
      fileList_7: [],                    // 已上传成功图片列表
      fileList_8: [],                    // 已上传成功图片列表
      fileList_9: [],                    // 已上传成功图片列表
      fileList_10: [],                    // 已上传成功图片列表
      fileList_11: [],                    // 已上传成功图片列表
      fileList_12: [],                    // 已上传成功图片列表

      // flag_1: false,
      // flag_2: false,
      
      dialogImageUrl: '',                // 预览图片路径
      dialogVisible: false,              // 预览对话框是否可见
    }
  },
  methods: {
    handleSuccess(rep, file, fileList, index, cb) { // 成功
      file.id = JSON.parse(file.response.data).fileId
      this['fileList_' + index] = fileList
      // console.log(`%cfileList:`, 'color: #00f;', fileList)
      cb ? cb(rep) : ''
    },
    handleError(err, file, fileList, index) { // 失败
      this['fileList_' + index] = fileList
    },
    handleRemove(file, fileList, index) { // 移除
      this['fileList_' + index] = fileList
    },

    // 文件超出个数限制时的钩子
    handleExceed(file, fileList) {
      this.$message.warning('超出上传数量限制！')
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeUpload(file) {
      // console.log(file.type)
      const isJPG = ['image/jpeg', 'image/png','image/gif'].includes(file.type)
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) { this.$message.error('请上传jpeg或png图片!') }
      // if (!isLt2M) { this.$message.error('上传头像图片大小不能超过 2MB!') }
      // return isJPG && isLt2M
      return isJPG
    },
    beforeUpload2(file, index, limitNum = 1) {
      let fileSize = file.size / 1024 / 1024 < 500
      if (this['fileList_' + index].length >= limitNum) {
        this.$message.warning('超出上传数量限制！')
      } else if (!['video/mp4'].includes(file.type)) {
        this.$message.warning('目前仅支持mp4文件格式上传！')
        return false
      } else if (!fileSize) {
        this.$message.warning('视频大小不能超过500MB！')
        return false
      } else {
        return true
      }
    },
    handleProcess(event, file, fileList, index) {
      // this['flag_'+x.index] = true
      // this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
  },
}